<template lang="pug">
.form-giftMessage.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.name" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.name }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")

      .input-container
        input.input(v-model="dataForm.phone" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.phone }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="phone" title="Teléfono" pattern="[0-9]{10}")

      .input-container
        input.input(v-model="dataForm.title" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.title }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="title" title="Título" :caseSensitive="true")

      .input-container
        label.label(:class="{ show: dataForm.message }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="message" title="Mensaje" :caseSensitive="true" :hideModified="true")
        textarea.input(v-model="dataForm.message" autocomplete="ño" rows="5" required)

      .input-container
        input.input(v-model="dataForm.from" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.from }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="from" title="De" :caseSensitive="true")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteGiftMessage")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gqlGiftMessage from '@/graphql/giftMessage'
import shSelectList from '@/components/elements/SelectList'

export default {
  name: 'FormGiftMessage',

  mixins: [mForm, mFilters, mDB],

  components: { shSelectList },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        phone: '',
        name: '',
        email: '',
        message: '',
        value: 0
      },
      giftMessagesRelated: [],
      msgArticleDefault: '',
      msgGiftMessageRelated: '',
      resolver: 'giftMessage',
      key: 'order',
      gql: gqlGiftMessage,
      delete: ['_id', 'createdAt', 'updatedAt', 'methodPay'],
      methodPay: '',
      message: { notRemove: true }
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newGiftMessage()
      } else {
        this.updateGiftMessage()
      }
    },

    newGiftMessage () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateGiftMessage () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteGiftMessage () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    },
    'dataForm.person': function (newVal) {
      this.dataForm.subfolder = newVal
      this.dataForm.folder = 'giftMessages'
    }
  }
}
</script>

<style lang="stylus">
.form-giftMessage
  position relative

.preview-text
  margin 1em 0

.title-stock
  font-weight 600
  font-size 1.1em
  margin 1em 0 .2em 0

.container-data-available
  padding 0 3em

.container-data-available > div
  display flex
  flex-direction column

.images-giftMessage-container, .images-measure-container
  display flex
  flex-wrap wrap
  gap 1em
  flex-direction row
  justify-content center
  margin-bottom 2em

.images-giftMessage-container > .image
  max-width 30em
  width 30%
  flex-shrink 0
  flex-basis 30em

.images-measure-container > .image
  max-width 40em
  width 30%
  flex-shrink 0
  flex-basis 40em

.images-giftMessage-container > .image > img
  width 30em

.buttons-image
  display flex
  gap 1em
  justify-content center

.button-load
  opacity .4

.button-load:hover
  opacity 1
</style>



// WEBPACK FOOTER //
// src/components/pages/giftMessage/Form.vue